import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableHeadRow,
    StyledTableCell,
    StyledTableBodyRow, StyledTable, StyledTableCellHeader
} from "../../../styles/MyStyles";
import {UpsertLookup} from "../../../logic/LookupHelper";

const NationalitiesPage = () => {
    const [nationalities, setNationalities] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNationalities = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(process.env.REACT_APP_NATIONALITIES_URL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setNationalities(data.data);
                    UpsertLookup('nationality', data.data);
                } else {
                    console.log('Fetch nationalities failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchNationalities();
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleRowTap = (id) => {
        editNationality(id);
    };

    const editNationality = (id) => {
        navigate(`edit/${id}`);
    };

    const createNationality = () => {
        navigate(`edit/`);
    };

    const filteredEntities = nationalities.filter(
        (entity) =>
            entity.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Calculate pagination values
    const totalEntities = filteredEntities.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedEntities = filteredEntities.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={9} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createNationality} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader>Name</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedEntities.map((entity) => (
                                <StyledTableBodyRow key={entity.id}
                                                    onClick={() => handleRowTap(entity.id)}>
                                    <StyledTableCell>{entity.name}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalEntities}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default NationalitiesPage;
